import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col, Badge, Translate } from '$common';
import CSSModules from 'react-css-modules';
import style from '../task-form.scss';



let FormField = props => (
  <div styleName="form-field">
    <label htmlFor={props.name}>{props.label}</label>
    <Field
      name={props.name}
      type={props.type || 'text'}
      component={props => {
        return(
          <input
            type={props.type}
            placeholder={props.placeholder}
            className={props.className}
            defaultValue={props.input.value}
            onBlur={props.input.onChange}
          />
        )
      }}
      styleName="field"
      placeholder={props.placeholder || ''}
    />
  </div>
);
FormField = CSSModules(FormField, style);

export default class Number extends Component {
  static type = 'number';
  static elementName = Translate.get('number');
  static icon = 'list-ol';

  render() {
    const { errors, data } = this.props;

    return (
      <div>
        <Row>
          <Col md="2/4">
            <FormField name={`${data}.limit[min]`} label="LENGTH LIMIT" type="number" placeholder="Min"/>
          </Col>
          <Col md="2/4">
            <FormField name={`${data}.limit[max]`} label="&nbsp;" type="number" placeholder="Max"/>
          </Col>
        </Row>
        {errors && errors.limit ? (
          <Badge type="error">
            {errors.limit}
          </Badge>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/number.js